import { GetStaticProps, NextPage } from "next";
import { Header } from "components/front/layout/Header";
import { Props as FooterProps } from "components/front/layout/Footer";
import React from "react";
import { ACTION_CONTENT_WIDTH } from "components/front/lp/animefurusato/calculation/theme";
import GeneralHead from "components/front/head/GeneralHead";
import styled from "styled-components";
import { Props as SimulatorProps } from "components/front/lp/animefurusato/calculation/Simulator";
import { Props as GeneralFootProps } from "components/front/layout/GeneralFoot";
import dynamic from "next/dynamic";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";

const Simulator = dynamic<SimulatorProps>(() => import("components/front/lp/animefurusato/calculation/Simulator"));
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));
const GeneralFoot = dynamic<GeneralFootProps>(() => import("components/front/layout/GeneralFoot").then((m) => m.GeneralFoot));

const SimulatorPage: NextPage<FrontAuthProps> = () => {
  return (
    <>
      <GeneralHead screenName="限度額シミュレーション" />
      <Header positionFixed={false} />
      <Root>
        <StyledSimulator />
      </Root>
      <Footer />
      <GeneralFoot />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default withFrontAuth(SimulatorPage);

const Root = styled.div`
  padding: 40px 0;
  background-color: #101010;
  color: #fff;
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
  @media screen and (min-width: 961px) and (max-width: 1440px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1441px) {
    font-size: 18px;
  }
`;
const StyledSimulator = styled(Simulator)`
  ${ACTION_CONTENT_WIDTH};
  @media screen and (max-width: 960px) {
    margin: 0 20px 40px;
  }
  @media screen and (min-width: 961px) {
    margin: 0 auto 80px;
  }
`;
